<template>
    <div v-if="visible">
        <el-dialog title="打印成绩" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="750px">    
            <div id="printContent2" ref="print">
                <div style="text-align:center;font-weight:bold;font-size:18px;">{{title}}</div>
                <div style="font-size:12px;color:#BBBBBB;text-align:center;">发布老师：{{sendUser}}，发布时间：{{sendDate}}</div>
                <div style="text-align:center;font-size:16px;margin-top:5px;">姓名:{{name}}</div>
                <el-table
                    :data="content"
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="id"
                    border
                    default-expand-all>
                    <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                    <el-table-column prop="subjectName" label="学科" ></el-table-column>
                    <el-table-column prop="score" label="成绩" ></el-table-column>
                    <el-table-column prop="avgScore" label="平均分" v-if="showAvgScoreSwitch"></el-table-column>
                </el-table>
                <div v-if="comment!=null && comment!=''">【老师评语】{{comment}}</div>
            </div> 
            <span slot="footer" class="dialog-footer">
                <!-- <el-button type="primary" v-print="'#printMe'">打印</el-button> -->
                <el-button type="primary" @click="print">打印</el-button>
            </span>
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http';
    import print from 'print-js';

    export default {
        data(){
            return{
                visible: false,
                scoreListId:"",
                userId:"",
                content:[],
                sendDate:"",
                sendUser:"",
                comment:"",
                title:"",
                name:"",
                // added by ligang 20250512
                showAvgScoreSwitch:false
            }
        },
        created:function () {
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            init(data, scoreListData){
                this.visible=true;
                this.scoreListId=data.scoreListId;
                this.userId=data.userId;
                this.name=data.name;
                this.getData();

                // 查询是否输出平均分
                this.showAvgScoreSwitch = scoreListData.showAvgScoreSwitch
            },
            getData(){
                let url  = this.getStudentSubjectScoreListUrl;
                let data = {
                    scoreListId:this.scoreListId,
                    userId:this.userId
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.sendUser=res.data.sendUser;
                        this.title=res.data.title;
                        this.sendDate=res.data.sendDate;
                        this.comment=res.data.comment;
                        this.content=res.data.content;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                });
            },
            dialogClose(done){
                done();
                this.$reload;
                this.visible=false;
            },
            print() { // 打印
                // console.log('打印总数：'+this.dataList.length);
                // this.loading=true;
                // this.loadingText="打印中...";
                printJS({
                    printable:'printContent2',
                    type:'html',
                    targetStyles:['*'],
                    ignoreElements:['no-print','bc','gb']
                })
                // setTimeout(function() {
                //    this.loading=false
                // }, 3000);
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/score/PrintScore.vue